import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/theme.min.css'
import store from './store'
import VeeValidate from 'vee-validate';
import { BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import '@progress/kendo-theme-material/dist/all.css'
import '@progress/kendo-ui'
import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import '@progress/kendo-ui/js/cultures/kendo.culture.sl-SI.js'
import { DialogInstaller } from '@progress/kendo-dialog-vue-wrapper'


Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VeeValidate);

Vue.use(DialogInstaller)
Vue.use(DropdownsInstaller)
Vue.use(DropDownList)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

